export default __webpack_public_path__ + "static/media/arrow_top_right.cf656061.svg";